module.exports = __webpack_public_path__ + "img/read-img7.5a53b705.png";